import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomToastrComponent } from './custom-toastr.component';
import { QdsButton, QuartzModule, QdsFormMessage } from "@quartzds/core-angular";
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [CustomToastrComponent],
  imports: [CommonModule, QdsButton, QuartzModule, QdsFormMessage, TranslateModule],
  exports: [CustomToastrComponent]
})
export class CustomToastrModule {}
